import { Progress } from "antd";
import React from "react";

function HalfCircleProgress({ value, total, width, height, sizeOfProgress }) {
  const percent = (value / total) * 100;

  // Decide color based on value
  let strokeColor = "#ff4d4f"; // default red
  if (value === 3) strokeColor = "#fa8c16"; // orange
  if (value >= 4) strokeColor = "#52c41a"; // green
  return (
    <div
      className="inline-block"
      style={{
        position: "relative",
        // width: 200,
        height: height,
        overflow: "hidden",
      }}
    >
      {/* Half circle progress */}
      <Progress
        type="dashboard"
        percent={percent}
        showInfo={false}
        strokeWidth={12}
        strokeLinecap="round" // ✅ rounded corners
        gapDegree={180}
        gapPosition="top"
        strokeColor={strokeColor}
        style={{ transform: "rotate(180deg)" }}
        size={sizeOfProgress}
      />

      {/* Custom text */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "38%",
          //   transform: "translate(-50%, -30%)",
          fontSize: "1.2rem",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {value}/{total}
      </div>
    </div>
  );
}

export default HalfCircleProgress;
